module.exports = __webpack_public_path__ + "static/media/19.93eb8201.gif";